import Settings from '../../../../settings/Settings';
import Controller from '../../controller/Controller';
import { $playerProfile, $energyTimer } from '../../../../backend/store';
import { TopUpVFX } from '../../vfx/topup/TopUpVFX';

const LABEL = {
    FONT: Settings.FONTS.LEAGUE_SPARTAN,
    SIZE: 50,
    TINT: 0xffffff,
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.5 },
    OFFSET_Y: -3,
};

export default class Energy extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private icon!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;
    private timerBg!: Phaser.GameObjects.Image;
    private timerLabel!: Phaser.GameObjects.BitmapText;
    private vfx!: TopUpVFX;

    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.width - 15;
        let y = 220;
        super(scene, x, y);

        this.setupBG();
        this.setupIcon();
        this.setupLabel();
        this.setupTimer();
        this.setupVFX();
        this.setupListeners();
    }

    setupVFX() {
        console.log({ x: this.x, y: this.y })
        this.vfx = new TopUpVFX(this.scene, 10, 'gui/energy/icon', { x: this.x - 100, y: this.y }, { min: 50, max: 150 })
        this.scene.add.existing(this.vfx)
    }

    vfxShow(startPoint: { x: number; y: number; }) {
        // console.log(startPoint)
        this.vfx.showTime(startPoint)
    }

    setupBG() {
        let frame = 'gui/energy/bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.bg.setOrigin(1, 0.5);
        this.add(this.bg);
    }

    setupTimer() {
        let frame = 'gui/energy/bg';

        this.timerBg = this.scene.add.image(0, 0, 'atlas', frame);
        this.timerBg.scale = 0.5;
        this.timerBg.setOrigin(1.5, -1);
        this.add(this.timerBg);

        let x = -this.timerBg.displayWidth / 2 - 20;
        let y = -10;

        let text = '';

        this.timerLabel = this.scene.add.bitmapText(x, y, LABEL.FONT, text, LABEL.SIZE / 2);
        this.timerLabel.setOrigin(1.5, -1);
        this.timerLabel.setTint(LABEL.TINT);
        this.timerLabel.setDropShadow(LABEL.SHADOW.X, LABEL.SHADOW.Y, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.timerLabel);
    }

    setupIcon() {
        const x = -this.bg.displayWidth / 2 + 40;
        const y = 0;

        let frame = 'gui/energy/icon';

        this.icon = this.scene.add.image(x, y, 'atlas', frame);
        this.icon.setOrigin(3.15, 0.5);
        this.add(this.icon);
    }

    setupLabel() {
        let x = -this.bg.displayWidth / 2 + 60;
        let y = LABEL.OFFSET_Y;

        let text = String($playerProfile.getState().player_wallet.currency_energy);

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, text, LABEL.SIZE);
        this.label.setOrigin(0.5);
        this.label.setTint(LABEL.TINT);
        this.label.setDropShadow(LABEL.SHADOW.X, LABEL.SHADOW.Y, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.label);
    }

    setupListeners() {
        $playerProfile.watch((state) => this.update(state.player_wallet.currency_energy));
        $energyTimer.watch((state) => this.updateEnergyTimer(state));
        this.scene.events.on('top_up_energy', this.vfxShow, this)
    }

    update(energy_val: number) {
        let text = String(energy_val);
        this.label.setText(text);
        if (energy_val == 400) {
            this.timerBg.setVisible(false);
            this.timerLabel.setVisible(false);
        } else {
            this.timerBg.setVisible(true);
            this.timerLabel.setVisible(true);
        }
    }

    updateEnergyTimer(time: number) {
        this.timerLabel.text = '0:' + (time < 10 ? '0' + time : time);
    }

    destroy() {
        this.scene.events.off(Controller.EVENTS.NEW_STAGE_STARTED, this.update, this);
        super.destroy();
    }
}
